import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "app" };
const _hoisted_2 = { class: "main-content" };
import HeaderComponent from './components/shared/Header.vue';
import FooterComponent from './components/shared/Footer.vue';
import Breadcrumb from './components/shared/Breadcrumb.vue';
import { useRoute } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        /**
         * 根组件
         * 包含整体布局结构：导航栏、内容区域、页脚
         */
        const route = useRoute();
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" 顶部导航栏 "),
                _createVNode(HeaderComponent),
                _createCommentVNode(" 主要内容区域 "),
                _createElementVNode("main", _hoisted_2, [
                    _createCommentVNode(" 面包屑导航 "),
                    _createVNode(Breadcrumb),
                    _createVNode(_component_router_view, null, {
                        default: _withCtx(({ Component }) => [
                            _createVNode(_Transition, {
                                name: "fade",
                                mode: "out-in"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                                        key: _unref(route).path
                                    }))
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createCommentVNode(" 页脚 "),
                _createVNode(FooterComponent)
            ]));
        };
    }
});
